import React, { useState, useEffect } from "react";
import { Typography, Table, Image } from "antd";
import UnRegisterFilters from "./filters";
import Pageloader from "../../components/loader/index";
import { dataKey } from "../../utils/Helpers";
import moment from 'moment';
import * as actionPage from "../../redux/actions/unRegisterRider.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import altimg from "../../assets/images/placeholder/placeimg50.png";

const { Title,  } = Typography;
const pageName = "Un Register Riders";

const UnRegisterRiders = (props) => {
  const [postData, setPostData] = useState(null);
  const [dataFilters, setDataFilters] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    if (props.pageFilter) {dataRun({...props.pageFilter})}
  }, [props.pageFilter]);

  const dataRun = (value)=>{
    const [start, end] = (value?.date === null || value?.date === undefined) ? "" : value?.date;
    const pageFilterData = {
      ...value,
      startDate: start === undefined ? moment().toISOString() : start.toISOString(),
      endDate: end === undefined ? moment().toISOString() : end.toISOString(),
    };
    delete pageFilterData["date"];
    props.actionPage.listAction(pageFilterData);
  }

  useEffect(() => {
    if (props?.pageData){setPostData(dataKey(props?.pageData))}
  }, [props?.pageData]);

  const paginationChange = (currentPage, limit) => {
    const pageData = {
      ...props.pageFilter,
      page: currentPage,
      limit: limit,
    };
    dataRun(pageData);
    // props.actionPage.filterAction(pageData);
  }

  const columns = [
    {
      title: 'Full Name',
      dataIndex: 'fullName',
      render: (value) => ( value || "-" )
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      render: (value) => ( value || "-" )
    },
    {
      title: 'Cnic',
      dataIndex: 'cnic',
      render: (value) => ( value || "-" )
    },
    {
      title: "Image",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (imgPath) => {return imgPath == "app/img/user.png" ? (<img alt="Profile Image" src={altimg} />) : imgPath != null ? (
       <Image alt="Profile Image" src={imgPath} />) : (<img alt="Profile Image" src={altimg} />)},
    },
    {
      title: 'Match Possibilities with percentages',
      dataIndex: 'searched_face_confidence_registration',
      render: (value) => ( value?.toFixed(2) || "-" )
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      }
    },
  ]



  return (<>
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName}</Title>
        <div></div>
      </div>
      <UnRegisterFilters dataFilters={dataFilters} setDataFilters={setDataFilters} />
      <div className="p-content">
        {props?.pageLoader ? <Pageloader /> :
          <Table
            dataSource={postData}
            columns={columns}
            pagination={props?.pagePagination?.length !== 0 ?{
              total: props?.pagePagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props?.pagePagination?.limit,
              defaultCurrent: props?.pagePagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {paginationChange(currentPage, pageSize)},
            } : ""}
            onRow={(r) => ({
              onDoubleClick: (e) => window.open(`/un-register/rider/${r.id}`),
            })}
          />
        }
      </div>
    </div>
  </>);
};

const mapStateToProps = (state) => {
  return {
    pageData: state.UnRegisterRiderReducer.initialData,
    pageLoader: state.UnRegisterRiderReducer.initialLoading,
    pagePagination: state.UnRegisterRiderReducer.initialPagination,
    pageFilter: state.UnRegisterRiderReducer.initialFilter,
    user: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnRegisterRiders);